"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.table.shortcut': 'Shortcut',
    'shortcuts.table.description': 'Description',
};
